import React from 'react';
import {Input} from '@spaced-out/ui-design-system/lib/components/Input';
import type {InputProps} from '@spaced-out/ui-design-system/lib/components/Input/Input';
import {
  type FieldValues,
  useController,
  type UseControllerProps,
} from 'react-hook-form';


type IFormInputProps<T extends FieldValues> = UseControllerProps<T> &
  InputProps;

export const TextInput = <T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  disabled,
  ...otherProps
}: IFormInputProps<T>) => {
  const {field, fieldState} = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
    disabled,
  });
  return (
    <Input
      size="medium"
      type="text"
      {...field}
      {...otherProps}
      error={Boolean(fieldState.error)}
      errorText={fieldState.error?.message}
    />
  );
};
